import React, { forwardRef } from "react";
import { IoMdClose } from "react-icons/io";
import "./input-styled.css";
const TextIconInput = forwardRef<HTMLInputElement, any>((props, ref) => {
  const {
    label,
    disable,
    placeholder,
    type,
    id,
    errors,
    name,
    value,
    icon,
    onChange,
    onBlur,
    lableStyle,
    inputStyle,
    divStyle,
    iconStyle,
    onkeypress,
    ClickIcon,
    minLength,
    maxLength,
    Style,
    onKeyDown,
    required,
    SvgIcon,
    disableColor,
    clearSearch,
    setShowSearch,
    readOnly,
  } = props;
  return (
    <div className={`w-full relative ${divStyle}`}>
      {label && (
        <label
          htmlFor={id}
          className={`font-medium text-[12px] text-[#1C2A3D] leading-[100%]  ${lableStyle} `}
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}
      {/* Disable default color #DCDCDC */}
      <input
        ref={ref} 
        disabled={disable}
        placeholder={placeholder}
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyPress={onkeypress}
        onKeyDown={onKeyDown}
        minLength={minLength}
        maxLength={maxLength}
        style={{ boxShadow: "0px 1px 2px 0px #1018280D", ...Style }}
        className={`w-full text-[14px] py-[12px] border rounded-[8px] h-full ${
          errors && "error_msg"
        } px-[14px] placeholder:text-[#9AA0A9] font-medium border-[#E6E7E8]  ${inputStyle} disabled:cursor-not-allowed disabled:text-[${disableColor ? '#1C2A3D' : '#DCDCDC'}] focus:outline-none focus:border-[#BEBEBE] leading-[16px] ${
          label && "mt-[6px]"
        } `}
        readOnly={readOnly}
        />

   {/* 
      {icon && (
        
        // <img
        //   src={icon}
        //   alt="icon"
        //   className={`absolute ${iconStyle || "left-2"} `}
        //   width={20}
        //   height={20}
        //   onClick={ClickIcon && ClickIcon}
        // />
      )} */}

  {/* Search with clear icon */}
    {icon && (
        value ? (
          <IoMdClose
            color={"black"}
            className={`absolute ${iconStyle || "left-2"} cursor-pointer`}
            onClick={(e) => {
              e.stopPropagation();
              if (typeof clearSearch === 'function') {
                clearSearch([]);
              }
              if (typeof setShowSearch === 'function') {
                setShowSearch("");
              }
            }}
          />
        ): (
            <img
            src={icon}
            alt="icon"
            className={`absolute ${iconStyle || "left-2"} cursor-pointer`}
            width={20}
            height={20}
            onClick={ClickIcon && ClickIcon}
          />
        )
      )}
      
      {SvgIcon && SvgIcon}
    </div>
  );
});

TextIconInput.displayName = "TextIconInput";
export default TextIconInput;
